import dateFormat from 'dateformat';
export function cuurentNextYear()
{
    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;
    const nextYearYY = nextYear.toString().slice(-2);
    return currentYear + '-' + nextYearYY;
}
export function academicSessionFromAugust() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();

    return month >= 7
        ? `${year}-${(year + 1).toString().slice(-2)}`
        : `${year - 1}-${year.toString().slice(-2)}`;
}
export function formatDate(unixTimestamp)
{
    if( unixTimestamp > 0 )
    {
        const date = new Date(unixTimestamp * 1000);
        return dateFormat(date, 'dd-mm-yyyy');
    }
    else
    {
        return '--';
    }    
}
export function reviewedDate(unixTimestamp) 
{
    const date = new Date(unixTimestamp * 1000);
    return dateFormat(date, "dd mmm, yyyy");
}
export function setYearList(isAll,isArchive)
{   
    let startYear = new Date().getFullYear();
    let length = 2;
    if( isAll === 1)
    {
        length = 7;
    }
    if( isArchive === 1)
    {
        startYear = new Date().getFullYear() - 2;
        length = 5;
    }
    return Array.from({ length: length }, (_, index) => startYear - index);
}
export function setMonthList()
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    return [
        { value: '1', label: appLanguage === 'hi' ? 'जनवरी' : 'January' },
        { value: '2', label: appLanguage === 'hi' ? 'फ़रवरी' : 'February' },
        { value: '3', label: appLanguage === 'hi' ? 'मार्च' : 'March' },
        { value: '4', label: appLanguage === 'hi' ? 'अप्रैल' : 'April' },
        { value: '5', label: appLanguage === 'hi' ? 'मई' : 'May' },
        { value: '6', label: appLanguage === 'hi' ? 'जून' : 'June' },
        { value: '7', label: appLanguage === 'hi' ? 'जुलाई' : 'July' },
        { value: '8', label: appLanguage === 'hi' ? 'अगस्त' : 'August' },
        { value: '9', label: appLanguage === 'hi' ? 'सितंबर' : 'September' },
        { value: '10', label: appLanguage === 'hi' ? 'अक्टूबर' : 'October' },
        { value: '11', label: appLanguage === 'hi' ? 'नवंबर' : 'November' },
        { value: '12', label: appLanguage === 'hi' ? 'दिसंबर' : 'December' }
    ];
}
export function setDateRange(year, month, isAll, isArchive, isMain=0) 
{
    let startDate = new Date(new Date().getFullYear() - 1, 0, 1); // January 1st last year
    let endDate = new Date(); // Current date
    if (isMain === 1) {
        startDate = new Date(new Date().getFullYear() - 1, 0, 1); // January 1st last year
        endDate = new Date(new Date().getFullYear(), 11, 31);   
    }
    if (isAll === 1) {
        startDate = new Date(new Date().getFullYear() - 6, 0, 1); // January 1st 6 years ago
        endDate = new Date(new Date().getFullYear(), 11, 31); // December 31st this year
    }

    if (isArchive === 1) {
        startDate = new Date(new Date().getFullYear() - 6, 0, 1); // January 1st 6 years ago
        endDate = new Date(new Date().getFullYear() - 1, 0, 1);
    }

    if (year > 0 && month > 0) {
        startDate = new Date(year, month - 1, 1); // First day of the month
        endDate = new Date(year, month, 0); // Last day of the month
    }

    if (year > 0 && month === 0) {
        startDate = new Date(year, 0, 1); // January 1st of the year
        endDate = new Date(year, 11, 31); // December 31st of the year
    }

    if (month > 0 && year === 0) {
        startDate = new Date(new Date().getFullYear(), month - 1, 1); // First day of this month in current year
        endDate = new Date(new Date().getFullYear(), month, 0); // Last day of this month in current year

        if (isArchive === 1) {
            startDate = new Date(new Date().getFullYear() - 1, month - 1, 1); // First day of this month last year
            endDate = new Date(new Date().getFullYear() - 1, month, 0); // Last day of this month last year
        }
    }

    startDate = Math.floor(startDate.getTime() / 1000); // Convert to Unix timestamp
    endDate = Math.floor(endDate.getTime() / 1000); // Convert to Unix timestamp

    return { startDate, endDate };
}
export function mmType(type)
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    if( type > 0 )
    {
        const myArray = {
            1: appLanguage === 'hi' ? 'सभापति' : 'Chairperson', 
            2: appLanguage === 'hi' ? 'सदस्य सचिव' : "Member Secretary", 
            3: appLanguage === 'hi' ? 'सदस्य' : "Member", 
            4: appLanguage === 'hi' ? 'सदस्य' : "Members"
        };
        return myArray[type];
    }
    else
    {
        return '--';
    }    
}
export function scType(spId)
{
    if( spId > 0 )
    {
        const myArray = {198:"2", 199:"3", 200:"4", 201:"5"};
        return myArray[spId];
    }
    else
    {
        return '0';
    }    
}
export function findItem(arr, key, value) {
  if (!Array.isArray(arr) || !key) {
    return {}; // return empty object
  }

  return arr.find(item => item && item[key] === value) || {};
}
export function LangValue(item, column) {
  if (!item || typeof item !== "object") return ""; // safeguard

  const appLanguage = localStorage.getItem('appLanguage') || 'en';
  const column_hi = `${column}_hi`;

  return appLanguage === 'hi'
    ? item[column_hi] || item[column] || ""
    : item[column] || "";
};
export function dynamicUrl(menu) 
{
    if (!menu) return "";

    const { parentMenu, sp_redirect, submenu } = menu;
    let result = '';
    if (parentMenu) {
        result = dynamicUrl(parentMenu);
        if (result) {
            result += '/';
        }
        result += LangValue(menu, 'sp_htaccess');
    } else {
        result = LangValue(menu, 'sp_htaccess');
    }
    if (sp_redirect === 1 && submenu && submenu.length > 0) {
        if (result) {
            result += '/';
        }
        result += LangValue(submenu[0], 'sp_htaccess');
    }
    //return result;
    return '/' + result.replace(/^\/+/, '').replace(/\/+/g, '/');
}
export function dynamicPageUrl(menu,column) 
{
    if (!menu) return "";

    const { parentPage, sp_redirect, submenu } = menu;
    let result = '';
    if (parentPage) {
        result = dynamicPageUrl(parentPage,column);
        if (result) {
            result += '/';
        }
        result += menu[column];
    } else {
        result = menu[column];
    }
    if (sp_redirect === 1 && submenu && submenu.length > 0) {
        if (result) {
            result += '/';
        }
        result += submenu[0][column];
    }
    //return result;
    return '/' + result.replace(/^\/+/, '').replace(/\/+/g, '/');
}
export function MetaInfo(obj, pKey, fKey, sep, t) {
    if (!obj || typeof obj !== 'object') {
        return '';
    }

    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    let pValue = appLanguage === 'hi' ? obj[pKey+'_hi'] || obj[pKey] : obj[pKey];
    let fValue = appLanguage === 'hi' ? obj[fKey+'_hi'] || obj[fKey] : obj[fKey];

    if (!pValue) {
        pValue = fValue || '';
    }
    if (obj.sp_id === 0) {
        pValue = (pKey === 'sp_meta_title') ? t(obj.sp_name) : `${t('IGDTUW')} ${t(obj.sp_name)}`;
    }

    if (!obj.parentPage) {
        return pValue || '';
    }

    const parentMeta = MetaInfo(obj.parentPage, pKey, fKey, sep, t);    
    return pValue ? (parentMeta ? `${parentMeta}${sep}${pValue}` : pValue || '') : '';
}

export function uniqueRefernce(num) 
{
    const BASE62 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let encoded = '';
    while (num > 0) {
        encoded = BASE62[num % 62] + encoded;
        num = Math.floor(num / 62);
    }
    return encoded.padStart(6, '0');
};
export function formatBytes(bytes) 
{
    if (bytes === 0) return '0 Bytes';
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
}
export function DownloadFile(Lang, FileEn, FileHi) {
    // Helper function to map file extensions to text
    const getFileTypeText = (ext, Lang) => {
        const fileTypes = {
            "pdf": Lang === 'hi' ? "पीडीएफ" : "PDF",
            "docx": Lang === 'hi' ? "वर्ड डॉक्यूमेंट" : "Word Document",
            "csv": Lang === 'hi' ? "सीएसवी" : "CSV",
            "zip": Lang === 'hi' ? "ज़िप संग्रह" : "ZIP Archive",
            "mp4": Lang === 'hi' ? "वीडियो (एमपी4)" : "Video (MP4)",
            "mp3": Lang === 'hi' ? "ऑडियो (एमपी3)" : "Audio (MP3)",
            "png": Lang === 'hi' ? "छवि (पीएनजी)" : "Image (PNG)",
            "jpg": Lang === 'hi' ? "छवि (जेपीजी)" : "Image (JPG)",
            "jpeg": Lang === 'hi' ? "छवि (जेपीजी)" : "Image (JPG)",
            "gif": Lang === 'hi' ? "छवि (जीआईएफ)" : "Image (GIF)",
        };
        return fileTypes[ext.toLowerCase()] || (Lang === 'hi' ? "अज्ञात टाइप" : "Unknown Type");
    };

    // Helper function to get file icons based on extension
    const getFileTypeIcon = (ext) => {
        const icons = {
            "pdf": "bi-filetype-pdf",
            "docx": "bi-filetype-docx",
            "csv": "bi-filetype-csv",
            "zip": "bi-file-zip",
            "mp4": "bi-filetype-mp4",
            "mp3": "bi-filetype-mp3",
            "png": "bi-filetype-png",
            "jpg": "bi-filetype-jpg",
            "jpeg": "bi-filetype-jpg",
            "gif": "bi-filetype-gif",
        };
        return icons[ext.toLowerCase()] || "bi-file-x-fill"; // Default icon for unknown types
    };

    if (FileEn.length > 0) {
        const file = Lang === 'hi' && FileHi.length > 0 ? FileHi[0] : FileEn[0];
        const fileExt = file.up_ext.substring(1); // Extracting extension without the dot
        const fileTypeText = getFileTypeText(fileExt, Lang);
        const fileTypeIcon = getFileTypeIcon(fileExt);

        // Conditional text for PDFs based on language and file availability
        const languageText = fileExt === 'pdf' && Lang === 'hi' && FileHi.length > 0 ? 'हिंदी' : 'English';
        const fileType = fileExt === 'pdf' ? `(${languageText})` : '';

        return `<a href="${global.config.uploadPath}${file.up_fname}${file.up_ext}" target="_blank" rel="noopener noreferrer" class='btn btn-info'>
                    <i class="bi ${fileTypeIcon}"></i> 
                    ${fileTypeText} ${fileType}, ${formatBytes(file.up_size)}
                </a>`;
    } else {
        return;
    }
}
